// This could be perfect for the modal split chart...
export const CHART_DATA = [
  {
    "id": "japan",
    "color": "hsl(195, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 253
      },
      {
        "x": "helicopter",
        "y": 163
      },
      {
        "x": "boat",
        "y": 198
      },
      {
        "x": "train",
        "y": 163
      },
      {
        "x": "subway",
        "y": 72
      },
      {
        "x": "bus",
        "y": 95
      },
      {
        "x": "car",
        "y": 114
      },
      {
        "x": "moto",
        "y": 58
      },
      {
        "x": "bicycle",
        "y": 45
      },
      {
        "x": "others",
        "y": 208
      }
    ]
  },
  {
    "id": "france",
    "color": "hsl(130, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 226
      },
      {
        "x": "helicopter",
        "y": 207
      },
      {
        "x": "boat",
        "y": 172
      },
      {
        "x": "train",
        "y": 18
      },
      {
        "x": "subway",
        "y": 153
      },
      {
        "x": "bus",
        "y": 170
      },
      {
        "x": "car",
        "y": 123
      },
      {
        "x": "moto",
        "y": 109
      },
      {
        "x": "bicycle",
        "y": 87
      },
      {
        "x": "others",
        "y": 259
      }
    ]
  },
  {
    "id": "us",
    "color": "hsl(331, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 16
      },
      {
        "x": "helicopter",
        "y": 166
      },
      {
        "x": "boat",
        "y": 176
      },
      {
        "x": "train",
        "y": 222
      },
      {
        "x": "subway",
        "y": 103
      },
      {
        "x": "bus",
        "y": 47
      },
      {
        "x": "car",
        "y": 95
      },
      {
        "x": "moto",
        "y": 267
      },
      {
        "x": "bicycle",
        "y": 24
      },
      {
        "x": "others",
        "y": 241
      }
    ]
  },
  {
    "id": "germany",
    "color": "hsl(97, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 282
      },
      {
        "x": "helicopter",
        "y": 295
      },
      {
        "x": "boat",
        "y": 282
      },
      {
        "x": "train",
        "y": 98
      },
      {
        "x": "subway",
        "y": 170
      },
      {
        "x": "bus",
        "y": 219
      },
      {
        "x": "car",
        "y": 9
      },
      {
        "x": "moto",
        "y": 11
      },
      {
        "x": "bicycle",
        "y": 291
      },
      {
        "x": "others",
        "y": 16
      }
    ]
  },
  {
    "id": "norway",
    "color": "hsl(242, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 257
      },
      {
        "x": "helicopter",
        "y": 198
      },
      {
        "x": "boat",
        "y": 207
      },
      {
        "x": "train",
        "y": 90
      },
      {
        "x": "subway",
        "y": 271
      },
      {
        "x": "bus",
        "y": 88
      },
      {
        "x": "car",
        "y": 120
      },
      {
        "x": "moto",
        "y": 15
      },
      {
        "x": "bicycle",
        "y": 96
      },
      {
        "x": "others",
        "y": 152
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/data/sample-chart-stacked-data.js